import { render, staticRenderFns } from "./stepItem.vue?vue&type=template&id=24430613&scoped=true"
import script from "./stepItem.vue?vue&type=script&lang=js"
export * from "./stepItem.vue?vue&type=script&lang=js"
import style0 from "./stepItem.vue?vue&type=style&index=0&id=24430613&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24430613",
  null
  
)

export default component.exports